import { render } from "./Banners.vue?vue&type=template&id=2712dd8e&scoped=true"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=2712dd8e&lang=scss&scoped=true"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2712dd8e"]])

export default __exports__